import React, { useState, useEffect } from "react";
import { ModalXoa } from "./ChucNang/ModalXoa";
import { ModalLienKetNganHangMB } from "./ChucNang/ModalLienKetNganHangMB";
import { ModalHuyLienKetNganHangMB } from "./ChucNang/ModalHuyLienKetNganHangMB";
import { ThemMoiTaiKhoan } from "./ThemMoiTaiKhoan";
import { PopoversBootrap } from "../../../components/GenericComponent/PopoversBootrap";

export const ContentTable = ({ dataDanhSach, onSearch }) => {
  const setModalEdit = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const ShowConfirmDelete = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const [dataFocus, setDataFocus] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  const [isModalXoa, setModalXoa] = useState(false);
  const toggleModalXoa = () => {
    setModalXoa(!isModalXoa);
  };
  const deleteBank = (item) => {
    setDataFocus(item);
    toggleModalXoa();
  };
  //Phần  lien kết ngân hàng
  const showDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalLienKet();
  };
  const [isModalLienKet, setModalLienKet] = useState(false);
  const toggleModalLienKet = () => {
    setModalLienKet(!isModalLienKet);
  };
  // end lien kết ngân hàng

  //Phần huy lien kết ngân hàng
  const showHuyDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalHuyLienKet();
  };
  const [isModalHuyLienKet, setModalHuyLienKet] = useState(false);
  const toggleModalHuyLienKet = () => {
    setModalHuyLienKet(!isModalHuyLienKet);
  };
  // end lien kết ngân hàng

  return dataDanhSach.List.map((item, index) => (
    <div className="custom-table-row" key={item.Id}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">{index + 1}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-20 flex-basis-29-sm ">
        <span className="mobile-column-name">Họ và tên</span>
        <div className="center-wrapper">
          <p className="text-center color-xanh-bold">{item.HoVaTen}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-15-sm ">
        <span className="mobile-column-name">Số tài khoản</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.SoTaiKhoan}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-15-sm">
        <span className="mobile-column-name">Ngân hàng</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.MaNganHang}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-15-sm ">
        <span className="mobile-column-name">Liên kết</span>
        <div className="center-wrapper">
          {item.IsDangKyNhanPushBDSD === true && (
            <p className="text-center color7">Đã liên kết</p>
          )}
          {item.IsDangKyNhanPushBDSD !== true && (
            <p className="text-center color7">Chưa liên kết</p>
          )}
        </div>
      </div>
      <div className="custom-table-cell flex-basis-15 flex-basis-11-4-sm   action-cell">
        <span className="mobile-column-name">Thao Tac</span>
        <div className="center-wrapper " style={{ fontSize: "20px" }}>
          {item.IsDangKyNhanPushBDSD && (
            <a href={() => false} onClick={(e) => showHuyDangKyPushBDSD(item)}>
              <PopoversBootrap
                contentText="Hủy liên kết ngân hàng"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <i
                  className="mdi mdi-pipe-disconnected"
                  style={{ color: "red" }}
                ></i>
              </PopoversBootrap>
            </a>
          )}

          {!item.IsDangKyNhanPushBDSD && item.MaNganHang == "MBBank" && (
            <a
              href={() => false}
              onClick={(e) => showDangKyPushBDSD(item)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Liên kết ngân hàng"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <i className="mdi mdi-pipe"></i>
              </PopoversBootrap>
            </a>
          )}
          {!item.IsDangKyNhanPushBDSD && (
            <a
              href={() => false}
              onClick={(e) => setModalEdit(item)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Sửa"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <img
                  style={{ marginLeft: "5px" }}
                  src="/app-assets/images/icon-edit-v2.png"
                />
              </PopoversBootrap>
            </a>
          )}
          {!item.IsDangKyNhanPushBDSD && (
            <a
              href={() => false}
              onClick={(e) => deleteBank(item)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Xóa"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <img
                  style={{ marginLeft: "5px" }}
                  src="/app-assets/images/icon-xoa-v2.png"
                />
              </PopoversBootrap>
            </a>
          )}
        </div>
      </div>
      {showEdit && (
        <ThemMoiTaiKhoan
          data={dataFocus}
          show={showEdit}
          onHide={handleCloseEdit}
        />
      )}
      <ModalXoa
        isModalVisible={isModalXoa}
        onSearch={onSearch}
        toggleModal={toggleModalXoa}
        item={dataFocus}
      />
      {isModalLienKet && (
        <ModalLienKetNganHangMB
          isModalVisible={isModalLienKet}
          onSearch={onSearch}
          toggleModal={toggleModalLienKet}
          item={dataFocus}
        />
      )}
      {isModalHuyLienKet && (
        <ModalHuyLienKetNganHangMB
          isModalVisible={isModalHuyLienKet}
          onSearch={onSearch}
          toggleModal={toggleModalHuyLienKet}
          item={dataFocus}
        />
      )}
    </div>
  ));
};
